import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("wyd_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => { localStorage.setItem("wyd_cookie_consent", "1"); setShow(false); };
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[1100] glass rounded-2xl p-5 fade-up">
      <div className="flex gap-3">
        <Cookie className="text-wyd-accent shrink-0" size={22} />
        <div>
          <p className="text-sm text-wyd-muted leading-relaxed">
            Usiamo cookie tecnici per farti vivere al meglio WYD. Continuando accetti la nostra{" "}
            <Link to="/privacy" className="text-wyd-accent underline">Privacy Policy</Link>.
          </p>
          <div className="mt-4 flex gap-3">
            <button data-testid="cookie-accept" onClick={accept}
              className="px-5 py-2 rounded-full bg-wyd-accent text-wyd-bg text-sm font-semibold hover:glow-magenta transition-shadow duration-300">
              Accetta
            </button>
            <button data-testid="cookie-reject" onClick={accept}
              className="px-5 py-2 rounded-full border border-white/15 text-wyd-muted text-sm hover:text-white transition-colors duration-200">
              Solo essenziali
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
